var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index"},[_c('keep-alive',{attrs:{"include":_vm.$store.state.keepAlivePages,"max":"5"}},[_c('router-view')],1),_c('tab-bar',{attrs:{"whichTabBarList":_vm.whichTabBarList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }